import { defineStore } from 'pinia'
import { ref, watch } from 'vue'
import { useRoute } from 'vue-router'

type UseErrorBar = {
    displayError(message: string): void
    clear(): void
}

export const useErrorBarStore = defineStore('errorBar', () => {
    const errorMessage = ref<string | null>(null)

    const displayError = (message: string) => {
        errorMessage.value = message
    }

    const clear = () => {
        errorMessage.value = null
    }

    const route = useRoute()

    watch(route, clear)

    return {
        errorMessage,
        displayError,
        clear,
    }
})

export const useErrorBar = (): UseErrorBar => {
    const { displayError, clear } = useErrorBarStore()

    return {
        displayError,
        clear,
    }
}
